import React from 'react';
import querystring from 'querystring';

import { Main, MainHeader, Body } from 'components/Main';
import { Panel, PanelTop } from 'components/Panel';
import PlayerLink from 'components/PlayerLink';
import RolloverController from 'components/RolloverController';
import ResultRollover from 'components/ResultRollover';
import { Table, Th, Td } from 'components/Table';

export default class JugLeaguePage extends React.Component {
    componentDidMount() {
        if (window !== undefined) {
            window.addEventListener('popstate', event => {
                let params = {};
                if (window.location.search) {
                    params = querystring.parse(window.location.search.substring(1));
                }
                this.props.browserBack(window.location.pathname, params);
            });
        }
    }

    render() {
        const { jugs } = this.props;
        return (
            <Main>
                <MainHeader />
                <Body id="jug-league-page">
                    <Panel border>
                        <PanelTop title="Jug League" buttons />
                        <JugLeagueTable jugs={jugs} />
                    </Panel>
                </Body>
            </Main>
        );
    }
}

const JugLeagueTable = ({ jugs }) => (
    <Table striped hover>
        <thead>
            <tr>
                <Th min="8" />
                <Th min="8" left>
                    Name
                </Th>
                <Th min="8">Num</Th>
                <Th left>Jugs</Th>
            </tr>
        </thead>
        <tbody>{jugs.map((row, index) => <JugLeagueRow key={index} index={index} row={row} />)}</tbody>
    </Table>
);

const JugLeagueRow = ({ row, index }) => (
    <tr>
        <Td min="8">{index + 1}</Td>
        <Td min="8" left>
            <PlayerLink pid={row[0].pid} fname={row[0].fname} lname={row[0].lname} />
        </Td>
        <Td min="8">{row.length}</Td>
        <Td left>{row.map((match, index) => <JugMatch key={index} match={match} />)}</Td>
    </tr>
);

class JugMatch extends React.Component {
    constructor(props) {
        super(props);
        this.controller = new RolloverController(this, 'bottom', 400);
        this.state = this.controller.getInitialState();
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
    }

    onMouseEnter() {
        this.controller.onMouseEnter(`/api/results/${this.props.match.mid}/summary`);
    }

    onMouseLeave() {
        this.controller.onMouseLeave();
    }

    render() {
        const { match } = this.props;
        let className = 'cc-jug-league-entry cc-icon-before';
        if (match.runs !== undefined) {
            className += ' cc-icon-jug-bat';
        } else if (match.wickets !== undefined) {
            className += ' cc-icon-jug-bowl';
        } else if (match.victims !== undefined) {
            className += ' cc-icon-jug-field';
        }
        let rollover;
        if (this.state.rollover) {
            rollover = (
                <ResultRollover
                    data={this.state.data}
                    onMouseEnter={this.onMouseEnter}
                    onMouseLeave={this.onMouseLeave}
                    directionInfo={this.controller.directionInfo}
                />
            );
        }
        return (
            <div ref="element" className={className} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                <div className="cc-rollover-wrapper">{rollover}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/jug-league/JugLeaguePage.jsx